import { Skeleton, Stack, Typography } from "@mui/material";
import { createFileRoute, Link } from "@tanstack/react-router";

import type { OrionBreadcrumbItem } from "@orion/OrionComponents/OrionBreadcrumbs";

import { useSite } from "@/api/zero/sites";
import { SettingsPageLayout } from "@/features/Settings/SettingsPageLayout";
import { EditSite } from "@/features/ZeroAdmin/sites/EditSite";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/_zeroAdmin/sites/$rjId",
)({
  component: SiteEditPage,
});

function SiteEditPage() {
  const { siteId, rjId } = Route.useParams();
  const { data: site, isLoading, isError } = useSite(rjId);

  const breadcrumbs: OrionBreadcrumbItem[] = [
    { label: "Admin" },
    {
      label: "Sites",
      to: "/settings/$siteId/sites",
      params: { siteId },
    },
  ];

  if (isLoading) {
    return (
      <SettingsPageLayout breadcrumbs={breadcrumbs} title="Site">
        <Stack sx={{ gap: 4 }}>
          <Skeleton variant="rounded" height={220} />
          <Skeleton variant="rounded" height={320} />
        </Stack>
      </SettingsPageLayout>
    );
  }

  if (isError || !site) {
    return (
      <SettingsPageLayout breadcrumbs={breadcrumbs} title="Site not found">
        <Stack sx={{ gap: 2 }}>
          <Typography
            variant="body2"
            sx={{ color: "error.main" }}
            data-testid="site-edit-error"
          >
            Failed to load site.
          </Typography>
          <Link to="/settings/$siteId/sites" params={{ siteId }}>
            Back to sites
          </Link>
        </Stack>
      </SettingsPageLayout>
    );
  }

  return <EditSite key={site.rj_id} siteId={siteId} site={site} />;
}
